/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butbewilligungab4Inputs */

const de__field_butbewilligungab4 = /** @type {(inputs: _Field_Butbewilligungab4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Bewilligung ab`)
};

/**

* @param {_Field_Butbewilligungab4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butbewilligungab4 = /** @type {((inputs?: _Field_Butbewilligungab4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butbewilligungab4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butbewilligungab4(inputs)
});
export { _field_butbewilligungab4 as "_field_BuTBewilligungAb" }